import React from 'react';
import { Field } from '../../../types';
import ColorPickerWithValidate from '../input/color-picker-with-validate';

interface Props {
  field: Field;
  setChange: (
    key: string,
    value: string | number | boolean | null,
    validation: any,
    isTeamDataValue: boolean
  ) => void;
  setValidation?: (key: string, value: string | number | boolean, validation: any) => void;
  isReadOnly?: boolean;
}

const ColorPickerField = ({ field, setChange, isReadOnly }: Props) => {
  const handleChange = (key: string, value: any | null) => {
    if (isReadOnly) return;

    if (setChange) {
      setChange(key, value, field.validation, !!field.isTeamDataValue);
    }
  };

  return (
    <ColorPickerWithValidate
      value={field.value as string}
      name={field.key}
      onValue={handleChange}
      validation={undefined}
    />
  );
};

export default ColorPickerField;
